export default __webpack_public_path__ + "locales/zh-CN/Ldap.json?hash=c9d207710d5876d3dbd11d9768977585";